import FlexPane from './_flex-pane.js'
import Text from './_text.js'

export default {
  name: 'FixedWidthTime',
  values: {
    timeBox: {
      configSet: FlexPane,
      configValues: {
        style: {
          minWidth: '60px',
        },
      },
    },
    timePart: {
      configSet: Text,
      configValues: {
        container: {
          flexBasis: '7px',
          flexGrow: 0,
          flexShrink: 0,
        },
        style: {
          textAlign: 'center',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
